/**
 * PURPOSE: Cliente del Cómputo General por evento (FTR-0066) en Winscore.
 * RESPONSIBILITIES: Leer el tablero del evento (disciplinas + ranking general), leer una disciplina (instituciones
 *   inscritas con puesto, participación y puntos) y guardarla con un reemplazo completo
 *   { entries: [{ idinstitution, place, participation }] }. El backend decide permisos (solo rol 1), valida los puestos
 *   y calcula los puntos oficiales; aquí no se traducen errores: se relanza el error de axios para que la interfaz lea
 *   el sobre V2 { ok:false, code, message, details } (computoGeneral.utils.js → readComputoError).
 * COLLABORATORS: httpService.js (Authorization: Bearer), area/ComputoGeneralArea/ComputoGeneralArea.jsx,
 *   backend/src/hayllis-v2/event-computo/event-computo.route.js.
 * ROUTE: winscore/src/services/eventComputoService.js
 */
import httpService from "./httpService.js";

export const EVENT_COMPUTO_ADMIN_BASE = "/api/hayllis/v2/admin/event-computo";

const eventPath = (idevent) => `${EVENT_COMPUTO_ADMIN_BASE}/events/${Number(idevent)}`;
const disciplinePath = ({ idevent, idsport }) => `${eventPath(idevent)}/sports/${Number(idsport)}`;

/** Tablero: { eventId, scoring, disciplines[], ranking[], lastUpdate }. */
export const getEventComputoBoard = async ({ idevent }) => {
  const response = await httpService.get(eventPath(idevent));
  return response.data?.data;
};

/** Disciplina: { eventId, scoring, discipline, institutions[], totals }. */
export const getEventComputoDiscipline = async ({ idevent, idsport }) => {
  const response = await httpService.get(disciplinePath({ idevent, idsport }));
  return response.data?.data;
};

/** Reemplazo completo de la disciplina (todas las instituciones inscritas). Devuelve la disciplina + `changed`. */
export const saveEventComputoDiscipline = async ({ idevent, idsport, entries }) => {
  const response = await httpService.put(disciplinePath({ idevent, idsport }), { entries });
  return response.data?.data;
};
